import * as React from "react";
import { SVGProps } from "react";

const Bakerytoken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 28 28"
    {...props}
  >
    <style>{".st4{fill:#ac562a}"}</style>
    <path
      fill="#fff"
      d="M21.6 13.9c.2-.1.5.1.5.3l.4 1.5c.1.2-.1.5-.3.5-.2.1-.5-.1-.5-.3l-.4-1.5c-.1-.2 0-.5.3-.5zM10.1 2.7c-.1-.2-.1-.5.1-.6l1.3-.9c.2-.1.5-.1.6.1.1.3.1.5-.1.7l-1.3.9c-.2 0-.5 0-.6-.2z"
    />
    <path
      fill="#ffae54"
      fillRule="evenodd"
      d="M16.8 8c-1.5-.3-3.1-.1-4.5.8 2-.7 4.3-.2 5.9 1.4 2.2 2.3 2.2 6 0 8.2-.3.3-.6.5-.9.7.8-.3 1.6-.7 2.2-1.4 1.6-1.6 2-3.9 1.4-5.9-1.7-.6-3.2-2-4.1-3.8z"
      clipRule="evenodd"
    />
    <radialGradient
      id="SVGID_1_"
      cx={-160.022}
      cy={828.812}
      r={1}
      gradientTransform="matrix(0 14.3808 14.2359 0 -11784.651 2315.62)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0.334} stopColor="#f7b450" />
      <stop offset={0.648} stopColor="#ffc977" />
      <stop offset={1} stopColor="#f90" />
    </radialGradient>
    <path
      fill="url(#SVGID_1_)"
      stroke="#ac562a"
      strokeWidth={1.072}
      d="M26.3 21c-3.6 6.7-12 9.2-18.6 5.5C1 22.9-1.4 14.4 2.2 7.7 4.6 3.3 9 .7 13.7.5c.6 0 1.1.3 1.4.9.3.6.5 1.4.4 2.2v.9c0 1.4.4 2.8 1 4-2.9-1.1-6.2.1-7.7 2.9-1.7 3.1-.5 6.9 2.5 8.6 3 1.7 6.9.5 8.5-2.5.9-1.7 1-3.7.3-5.4 1.2.6 2.5.9 3.9.9.8 0 1.5-.1 2.3-.3.4-.1.9-.1 1.2.1.3.2.5.4.5.7.1 2.5-.5 5.1-1.7 7.5z"
    />
    <path
      fill="#ac562a"
      stroke="#ac562a"
      strokeWidth={1.072}
      d="m22.7 18.3.5-.2c.4 1-.1 1.9-.4 2.6v.1c-.2.4-.4.7-.4 1-.1.5-.1 1 0 1.3.1.3.4.6.8.7.3.1.8 0 1.4-.4 2.4-2.8 3.5-6.4 3.3-9.8 0-.3-.2-.6-.5-.8-.3-.2-.8-.2-1.2-.1-.7.2-1.5.3-2.2.3-1.4 0-2.7-.3-3.9-1 .7 1.7.6 3.6-.2 5.3-.1.3-.3.5-.5.8.4-.1.8-.3 1.4-.7.7-.5 1.6 0 1.9.9zm0 0c.3.8-.1 1.5-.4 2.2-.2.4-.4.8-.5 1.2l.9-3.4zM13.1 8.1c-1.4.4-2.5.2-3.3-.2-.8-.5-1.5-1.2-1.8-2-.4-.9-.5-1.8-.3-2.6s.6-1.4 1.2-1.7C10.6.9 12.4.5 14.1.5c.5 0 .9.3 1.2.8.3.5.4 1.2.3 1.8-.1.4-.1.9-.1 1.4 0 1.4.4 2.8 1 4-1.1-.5-2.3-.6-3.4-.4z"
    />
    <circle cx={3.8} cy={11.2} r={0.7} className="st4" />
    <circle cx={14.2} cy={23.7} r={0.7} className="st4" />
    <circle cx={9.8} cy={24.3} r={1.2} className="st4" />
  </svg>
);

export default Bakerytoken;
